import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Typography,
  Chip,
} from '@mui/material';
import { EmojiEvents as TrophyIcon } from '@mui/icons-material';

const RankingTable = ({ players, showStore = false }) => {
  // Helper function to get medal color based on position
  const getMedalColor = (position) => {
    switch (position) {
      case 1: return 'rgba(255, 215, 0, 0.15)'; // Gold
      case 2: return 'rgba(192, 192, 192, 0.15)'; // Silver
      case 3: return 'rgba(205, 127, 50, 0.15)'; // Bronze
      default: return 'transparent';
    }
  };

  // Helper function to get position icon
  const getPositionIcon = (position) => {
    switch (position) {
      case 1:
        return <TrophyIcon sx={{ color: '#FFD700', fontSize: '1.2rem' }} />;
      case 2:
        return <TrophyIcon sx={{ color: '#C0C0C0', fontSize: '1.2rem' }} />;
      case 3:
        return <TrophyIcon sx={{ color: '#CD7F32', fontSize: '1.2rem' }} />;
      default:
        return position;
    }
  };

  return (
    <TableContainer 
      component={Paper} 
      sx={{ 
        borderRadius: 2, 
        border: '1px solid', 
        borderColor: 'divider',
        overflow: 'hidden'
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center" width={50}>#</TableCell>
            <TableCell>Jugador</TableCell>
            {showStore && <TableCell>Tienda</TableCell>}
            <TableCell align="center">Partidas</TableCell>
            <TableCell align="center">Victorias</TableCell>
            <TableCell align="center">Puntos</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {players.map((player, index) => (
            <TableRow 
              key={player.id}
              sx={{ 
                bgcolor: getMedalColor(index + 1),
                '&:hover': {
                  bgcolor: (theme) => 
                    index < 3 
                      ? getMedalColor(index + 1)
                      : theme.palette.action.hover
                }
              }}
            >
              <TableCell align="center">
                {getPositionIcon(index + 1)}
              </TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Avatar 
                    sx={{ 
                      width: 32, 
                      height: 32, 
                      bgcolor: '#c89e38',
                      border: index < 3 ? '2px solid' : 'none',
                      borderColor: index === 0 ? '#FFD700' : 
                                 index === 1 ? '#C0C0C0' : 
                                 index === 2 ? '#CD7F32' : 'transparent'
                    }}
                  >
                    {player.name[0]}
                  </Avatar>
                  <Box>
                    <Typography variant="body2" fontWeight="medium">
                      {player.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {player.torCode}
                    </Typography>
                  </Box>
                </Box>
              </TableCell>
              {showStore && (
                <TableCell>
                  <Chip 
                    label={player.store}
                    size="small"
                    sx={{ 
                      bgcolor: 'background.paper',
                      border: '1px solid',
                      borderColor: 'divider'
                    }}
                  />
                </TableCell>
              )}
              <TableCell align="center">{player.matches}</TableCell>
              <TableCell align="center">{player.wins}</TableCell>
              <TableCell align="center">
                <Typography 
                  variant="body2" 
                  fontWeight="bold"
                  sx={{ 
                    color: index < 3 ? 
                      index === 0 ? '#FFD700' : 
                      index === 1 ? '#C0C0C0' : 
                      '#CD7F32' : '#c89e38'
                  }}
                >
                  {player.points}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RankingTable; 